const VEHICLE_TYPE_LABELS = {
  car: "PKW",
  trucks: "LKW",
  agri: "Agrar",
  moto: "Motorrad",
};

const FUEL_LABELS = {
  petrol: "Benzin",
};

export function vehicleTypeLabel(value) {
  return VEHICLE_TYPE_LABELS[(value || "").toLowerCase()] || value;
}

export function fuelLabel(value) {
  return FUEL_LABELS[(value || "").toLowerCase()] || value;
}

// Shared English-vocabulary vehicle type labels — used by both Alientech and
// MagicMotorsport, whose raw vehicle_type values overlap (bike/car/tractor/
// truck/boat/petrol), plus a few extra types only MagicMotorsport has.
const ALIENTECH_VEHICLE_TYPE_LABELS = {
  bike: "Motorrad",
  car: "Pkw",
  tractor: "Agrar",
  truck: "Lkw",
  boat: "Boot",
  bus: "Bus",
  lcv: "Nutzfahrzeug",
  other: "Sonstige",
};

const ALIENTECH_FUEL_LABELS = {
  petrol: "Benzin",
};

export function alientechVehicleTypeLabel(value) {
  return ALIENTECH_VEHICLE_TYPE_LABELS[(value || "").toLowerCase()] || value;
}

export function alientechFuelLabel(value) {
  return ALIENTECH_FUEL_LABELS[(value || "").toLowerCase()] || value;
}

const ECU_TYPE_LABELS = {
  ecm: "ECU",
  tcm: "TCU",
};

export function ecuTypeLabel(value) {
  return ECU_TYPE_LABELS[(value || "").toLowerCase()] || value;
}
